import { logger } from '@/lib/logger';

const FPTI = {
  isWpsGuestUpgradeEligible: {
    logEligibility: (fptiKey: string): void => {
      logger.fpti(`wps_upgrade_interstitial_${fptiKey}`, {
        state_name: 'wps_upgrade_interstitial_eligibility',
        transition_name: `wps_upgrade_interstitial_${fptiKey}`,
      });
    },
  },
};

export { FPTI };
